import etReferenceDataConfig from '@/api/config/etReferenceDataConfig'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteReference(interfaceId: string, id: string): Promise<void> {
  await etReferenceDataConfig.delete(interfaceId, id)
}

function useDeleteReference() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: any) => deleteReference(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.etReference])
        toast.success(t('deleteEtReferenceSuccess'))
        closeModal()
      },
      onError: (error: any) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )

  // return mutate
}

export default useDeleteReference
